const ConversionArrow = () => (
    <svg
        width='13'
        height='15'
        viewBox='0 0 13 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            opacity='0.5'
            d='M12 5.76795C13.3333 6.53775 13.3333 8.46225 12 9.23205L3 14.4282C1.66667 15.198 -7.31543e-07 14.2358 -6.64245e-07 12.6962L-2.09983e-07 2.30385C-1.42685e-07 0.764248 1.66667 -0.198005 3 0.571796L12 5.76795Z'
            fill='white'
        />
    </svg>
);

export default ConversionArrow;
